import React, { Component } from "react";
import SessionErrorPage from "../pages/Errors/SessionErrorPage";

class ErrHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errCaught: false,
    };
  }

  static getDerivedStateFromError() {
    return { errCaught: true };
  }

  render() {
    if (this.state.errCaught) {
      return <SessionErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrHandler;
